export const UHC_STORE_UTM_SOURCE = 'uhc-store';

export const AMAZON_HBC_SOURCE = 'amazon-hbc';
